import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { catchError, map, Observable, take, tap, throwError } from 'rxjs';
import { Approval, StartupInvestorDashboardResponse } from '../domain';
import { ApiEndpointService } from './api-endpoint.service';
import * as StartupDashBoardActions from "src/app/core/state/startup-dashboard";
import * as ProfileActions from "src/app/core/state/profile/profile.action";
import { AuthService } from './auth.service';
import { ToastAlertService } from 'src/app/shared/utils/toast.service';
import { getBrandDetails } from '../state/global';

@Injectable({
  providedIn: 'root'
})
export class StartupDashboardService {

  constructor(private http: HttpClient, private store: Store, private authService: AuthService, private toastService: ToastAlertService) { }

  public getStartUpDashboard(): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.STARTUP_DASHBOARD);
    return this.http.get(url).pipe(
      map((response: StartupInvestorDashboardResponse) => {
        console.info(`startupDashboard GET ( Received startupDashboard `);
        return response.data;
      }),
      catchError((fault: HttpErrorResponse) => {
        // fault.error lacks .message for network-level failures (status 0,
        // CORS, connection reset) - it's not always the {message: string}
        // shape a backend JSON error returns. Fall back so this warning is
        // actually informative instead of literally "( undefined )".
        /* SAN-567: skip warn for network drops (status 0) / 5xx - transient infra faults, same treatment as the profile_completeness call below. */
        if (fault?.status && fault.status < 500) {
          console.warn(`startupDashboard( ${fault.error?.message || fault.message || fault.status} )`);
        }
        return throwError(() => fault);
      })
    );
  }

  public getStartUpCompleteness(): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.STARTUP_PROFILE_COMPLETENESS);
    return this.http.get(url).pipe(
      map((response: StartupInvestorDashboardResponse) => {
        console.info(`startupDashboard GET ( Received getStartUpCompleteness `);
        return response.data;
      }),
      tap((res: any)=>{
        if(res?.isRejected){
          setTimeout(()=>{
            this.store.pipe(select(getBrandDetails)).pipe(take(1)).subscribe((res)=> {
              if(res) {
                if(res.features?.logout_on_rejection)  {
                  this.toastService.showToast('Your profile is rejected', 'error');
                  this.authService.logout();
                }
              }
            })
          }, 1000)
        }
      }),
      catchError((fault: HttpErrorResponse) => {
        // fault.error lacks .message for network-level failures (status 0,
        // CORS, connection reset) - it's not always the {message: string}
        // shape a backend JSON error returns. Fall back so this warning is
        // actually informative instead of literally "( undefined )".
        /* SC-SAAS-FRONTEND-49 (SAN-567): skip warn for network drops (status 0) / 5xx - transient infra faults. */
        if (fault?.status && fault.status < 500) {
          console.warn(`startupDashboard( ${fault.error?.message || fault.message || fault.status} )`);
        }
        return throwError(() => fault);
      })
    );
  }

  public sendApprovalRequest(data: Approval): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.STARTUP_DASHBOARD_APPROVAL);
    const params = data;
    return this.http.patch(url, params).pipe(
      tap(() => this.store.dispatch(new StartupDashBoardActions.GetProfileCompleteness())),
      map((response: any) => {
        console.info(` sendApproval startupDashboard GET ( send sendApproval startupDashboard`);
        return response.message;
      }),
      catchError((fault: HttpErrorResponse) => {
        console.warn(`sendApproval( ${fault.error?.message || fault.message || fault.status} )`);
        return throwError(() => fault);
      })
    );
  }

  public raisingFunds(): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.STARTUP_DASHBOARD_RAISING_FUNDS);
    return this.http.patch(url, {}).pipe(
      tap(() => this.store.dispatch(new StartupDashBoardActions.GetProfileCompleteness())),
      map((response: any) => {
        this.store.dispatch(new ProfileActions.GetProfile());
        console.info(` raisingFunds startupDashboard PATCH ( send raisingFunds startupDashboard`);
        return response.message;
      }),
      catchError((fault: HttpErrorResponse) => {
        console.warn(`raisingFunds( ${fault.error?.message || fault.message || fault.status} )`);
        return throwError(() => fault);
      })
    );
  }
  public notRaisingFunds(): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.STARTUP_DASHBOARD_NOT_RAISING_FUNDS);
    return this.http.patch(url, {}).pipe(
      tap(() => this.store.dispatch(new StartupDashBoardActions.GetProfileCompleteness())),
      map((response: any) => {
        this.store.dispatch(new ProfileActions.GetProfile());
        console.info(` raisingFunds startupDashboard PATCH ( send raisingFunds startupDashboard`);
        return response.message;
      }),
      catchError((fault: HttpErrorResponse) => {
        console.warn(`raisingFunds( ${fault.error?.message || fault.message || fault.status} )`);
        return throwError(() => fault);
      })
    );
  }
}
